import React, { Component } from 'react'
// import { Link } from 'react-router'
import { connect } from 'react-redux'
import { translation } from '../../../utils/helpers'
import { renderFullDate } from '../../../utils/time'
import { triggerPopupActionBG, triggerPopup } from '../../../actions/backdrop'
import { openOverlay } from '../../../actions/common'

import { sendInvitation, getCarOwnerStatus } from '../../../actions/carownerportal'

import { CarOwnerPortalIcons, ModalIcons } from '../../elements/icons'

import EventEmitter from '../../../utils/events'

import Modal from '../../components/Modal'

import Icon from '../../elements/icon'
import LabelWrapper from '../../elements/labelWrapper'
import Inline from '../../elements/inline'

import './carownerportalinvitestatus.scss'
import Spinner from '../../elements/spinner'

class CarOwnerPortalInviteStatus extends Component {
  constructor (props) {
    super()
    this.state = {
      showSendModal: false
    }
    this.getCarOwnerStatus = this.getCarOwnerStatus.bind(this)
    this.openOverlay = this.openOverlay.bind(this)
    this.openCarOwnerResendPopup = this.openCarOwnerResendPopup.bind(this)
    this.sendInvitation = this.sendInvitation.bind(this)
  }

  componentDidMount () {
    this.getCarOwnerStatus(this.props.orderId)
    EventEmitter.addListener('UPDATE_CAROWNER', this.getCarOwnerStatus, this)
  }

  componentWillUnmount () {
    EventEmitter.removeListener('UPDATE_CAROWNER', this.getCarOwnerStatus)
  }

  openOverlay (e) {
    e.persist()
    this.setState({
      showSendModal: false
    })
    this.props.triggerPopup(false)
  }

  openCarOwnerResendPopup (date) {
    this.setState({
      showSendModal: true,
      carOwnerPortalResend: {
        date: renderFullDate(date)
      }
    })
    this.props.triggerPopup(true)
  }

  getCarOwnerStatus () {
    let orderId = this.props.orderId
    this.setState({carOwnerPortalStatus: null}, () => {
      this.props.getCarOwnerStatus(orderId).then((res) => {
        this.setState({ carOwnerPortalStatus: res.data })
      })
    })
  }

  sendInvitation () {
    const param = {
      orderId: this.props.orderId,
      isSendSMS: true,
      IsSendEmail: true
    }

    this.props.sendInvitation(param).then((res) => {
      this.props.triggerPopup(false)
      this.setState({
        showSendModal: false
      })
      this.getCarOwnerStatus()

      // window.toastr.success(translation('18189'), translation('13424'))
    }, () => {
      // Err saving
      window.toastr.error(translation('18190'), translation('216'))
    })
  }

  render () {
    if (!this.props.orderId) return null
    // Check permissions
    // let hasData = this.state.carOwnerPortalStatus && this.state.carOwnerPortalStatus.Logs
    return (
      <LabelWrapper labelText={18217} className='carownerportalinvitestatus'>
        {this.renderContent() || <Spinner size={2} />}
      </LabelWrapper>
    )
  }

  renderContent () {
    // Render car owner portal status and invitation options
    // console.log('state (car owner)', this.state)
    let noticeText = ''
    let dateOfStatusText = ''
    let date = ''
    let statusText = ''
    let statusIcon = CarOwnerPortalIcons.NotSent
    let showSendLink = false
    let sendLinkText = translation(18264)       // Send invitation
    let sendButtonText = translation(1301)
    let carOwnerPortalLatestLogDate = null
    let carOwnerPortalStatus = this.state.carOwnerPortalStatus

    if (typeof carOwnerPortalStatus !== `undefined` && this.state.carOwnerPortalStatus !== null) {
      if (carOwnerPortalStatus && carOwnerPortalStatus.Logs && carOwnerPortalStatus.Logs.length > 0) carOwnerPortalLatestLogDate = carOwnerPortalStatus.Logs[0].Date
      switch (carOwnerPortalStatus.Status) {
        case 1:
          // Active
          statusText = translation(295)           // Active
          statusIcon = CarOwnerPortalIcons.Active
          showSendLink = false
          noticeText = translation(18221)         // The car owner portal is active and can be used by car owner
          dateOfStatusText = translation(18254)   // Accepted by the car owner
          date = this.state.carOwnerPortalStatus.Logs.filter(x => x.Status === 1).slice(0, 1)[0].Date   // Latest date of car owner accept (active)
          break
        case 2:
          // NotInvited
          statusText = translation(18262)         // No invitation sent
          statusIcon = CarOwnerPortalIcons.NotSent
          showSendLink = true
          noticeText = translation(18222)         // no invitation has been sent to the car owner
          dateOfStatusText = null
          break
        case 3:
          // Invited
          statusText = translation(15000)         // Awaiting approval
          statusIcon = CarOwnerPortalIcons.Awaiting
          showSendLink = true
          sendLinkText = translation(18219)       // Re-send invitation
          sendButtonText = translation(18234)     // Re-send
          noticeText = translation(18223)         // An invitation has been sent by SMS or e-mail to the car owner, pending for approval of terms and conditions
          dateOfStatusText = translation(18255)   // The car owner was invited
          date = carOwnerPortalStatus.Logs.filter(x => x.Status === 3).slice(0, 1)[0].Date   // Latest date of invite
          break
        case 4:
          // RejectedByCarOwner
          statusText = translation(18263)         // Declined
          statusIcon = CarOwnerPortalIcons.Declined
          showSendLink = true
          sendLinkText = translation(18219)       // Re-send invitation
          sendButtonText = translation(18234)     // Re-send
          noticeText = translation(18233)         // The invitation has previously been rejected by the car owner. Please ensure a verbal consent before re-sending the invitation.
          dateOfStatusText = translation(18227)   // Rejected by car owner
          date = carOwnerPortalStatus.Logs.filter(x => x.Status === 4).slice(0, 1)[0].Date   // Latest date of car owner decline
          break
      }
    } else {
      statusText = translation(18262)         // Declined
      statusIcon = CarOwnerPortalIcons.NotSent
      showSendLink = true
      sendLinkText = translation(18264)       // Re-send invitation
      sendButtonText = translation(18234)     // Re-send
      noticeText = translation(18222)
    }

    const renderSendLink = () => {
      let mailOrPhoneAvailable = false
      if (typeof carOwnerPortalStatus !== 'undefined' && carOwnerPortalStatus !== null) {
        mailOrPhoneAvailable = carOwnerPortalStatus.Phone || carOwnerPortalStatus.Mail
      }

      return (
        <div>
          <a className={mailOrPhoneAvailable ? 'link-send' : 'link-send__disabled'} href='#' onClick={() => mailOrPhoneAvailable ? this.openCarOwnerResendPopup(carOwnerPortalLatestLogDate) : window.toastr.error(translation('18297'), translation('216'))} >{sendLinkText}</a>
        </div>
      )
    }

    return (
      <div>
        <Inline>
          {statusText}
          <Icon icon={statusIcon} size='xs' />
        </Inline>
        {showSendLink && renderSendLink()}
        {this.state.showSendModal && this.renderSendInvitationModal(noticeText, dateOfStatusText, date, sendLinkText, sendButtonText)}
      </div>
    )
  }

  renderSendInvitationModal (noticeText, dateOfStatusText, date, headerText, actionText) {
    const closeSendModal = () => {
      this.props.triggerPopup(false)
      this.setState({ showSendModal: false })
    }
    return (
      <div className='sendinvitation_modal'>
        <Modal
          show={this.state.showSendModal}
          onClose={closeSendModal}
          header={headerText}
          icon={ModalIcons.Note}
          bottomBarProps={{
            actionLabelText: actionText,
            onActionClick: this.sendInvitation
          }}>
          <div>
            <div className='text-bold'>{noticeText}</div>
            {dateOfStatusText} {renderFullDate(date)}
          </div>
        </Modal>
      </div>
    )
  }
}

CarOwnerPortalInviteStatus.defaultProps = {
  orderId: 0
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  getCarOwnerStatus,
  triggerPopupActionBG,
  openOverlay,
  triggerPopup,
  sendInvitation
})(CarOwnerPortalInviteStatus)



// WEBPACK FOOTER //
// ./src/app/shared/components/CarOwnerPortalInviteStatus/index.js